import { DrawingModel } from '@/models/DrawingModel'
import { PenSetting } from '@/const/PenSetting'
import LzString from 'lz-string'

/**
 * 座標情報だけを抽出したストローク情報
 */
type PointOnlyStroke = {
  /** ストロークの座標情報 */
  points: DrawingModel.Point[][]
}

/**
 * 手書き関連のデータ処理群
 */
export default class StrokeUtils {
  /**
   * ストローク情報を座標だけのJSON文字列(DB保存用)に変換・圧縮する
   *
   * @param strokes ストローク情報
   * @returns 座標情報だけを抽出したJSON文字列を圧縮したもの
   */
  public static strokesToCompressedJson(strokes: DrawingModel.Stroke[]): string {
    // 座標情報だけを抽出
    const points: DrawingModel.Point[][] = []
    for (let i = 0; i < strokes.length; i++) {
      points.push(strokes[i].points)
    }

    // DB保存用の型に変換
    const pointOnlyStroke: PointOnlyStroke = {
      points: points,
    }

    // JSON文字列化
    const jsonStr = JSON.stringify(pointOnlyStroke)

    // lz-stringでURI圧縮して返す
    return LzString.compressToEncodedURIComponent(jsonStr)
  }

  /**
   * 圧縮済みの座標だけのJSON文字列(DB保存用)をストローク情報に変換する
   *
   * @param complessedJsonStroke 圧縮済みの座標情報だけを抽出したJSON文字列(DB保存用)
   * @returns ストローク情報
   */
  public static compressedJsonToStrokes(complessedJsonStroke: string): DrawingModel.Stroke[] {
    // lz-stringで展開
    const jsonStr = LzString.decompressFromEncodedURIComponent(complessedJsonStroke)

    // JSON文字列をオブジェクト型に変換
    const pointOnlyStroke: PointOnlyStroke = JSON.parse(jsonStr)

    // レスポンス用ストローク情報定義
    const strokes: DrawingModel.Stroke[] = []

    // 座標情報とデフォルトペン情報でストローク情報を生成
    for (let i = 0; i < pointOnlyStroke.points.length; i++) {
      strokes.push({
        pen: PenSetting.PEN_BLACK,
        points: pointOnlyStroke.points[i],
      })
    }

    // ストローク情報を返す
    return strokes
  }
}
